import { _ } from "vue-underscore";

const aicBuilds = {
  state: {},
  mutations: {},
  getters: {
    getMandateById: state => id => {
      return state.data[id] ? state.data[id] : null;
    },
    getMandatesByMeeting: (state, getters, rootState, rootGetters) => meetingId => {
      return _.filter(Object.values(state.data), item => {
        return item.meeting_id == meetingId;
      });
    },
    getMandateByMeetingAndBuildingOwner: state => (meetingId, buildingOwnerId) => {
      return _.find(Object.values(state.data), item => {
        return item.meeting_id == meetingId && item.building_owner_id == buildingOwnerId;
      });
    },
    getMandatesRepresentedByMeeting: (state, getters) => (
      meetingId,
      buildingOwnerId,
      contactId
    ) => {
      return _.filter(Object.values(state.data), item => {
        return (
          item.meeting_id == meetingId &&
          item.building_owner_id !== buildingOwnerId &&
          (item.representant_owner_id === buildingOwnerId ||
            item.representant_contact_id === contactId)
        );
      });
    },
  },
  actions: {},
};
export default aicBuilds;
